// extracted by mini-css-extract-plugin
export default {"input-textarea-container":"styles_input-textarea-container__E527G","input-textarea":"styles_input-textarea__y852g"};